// Sticky Plugin v1.0.4 for jQuery
// =============
// Author: Anthony Garand
// Improvements by German M. Bravo (Kronuz) and Ruud Kamphuis (ruudk)
// Improvements by Leonardo C. Daronco (daronco)
// Created: 02/14/2011
// Date: 07/20/2015
// Website: http://stickyjs.com/
// Description: Makes an element on the page stick on the screen as you scroll
//              It will only set the 'top' and 'position' of your element, you
//              might need to adjust the width in some cases.

(function (factory) {
    if (typeof define === 'function' && define.amd) {
        // AMD. Register as an anonymous module.
        define(['jquery'], factory);
    } else if (typeof module === 'object' && module.exports) {
        // Node/CommonJS
        module.exports = factory(require('jquery'));
    } else {
        // Browser globals
        factory(jQuery);
    }
}(function ($) {
    var slice = Array.prototype.slice; // save ref to original slice()
    var splice = Array.prototype.splice; // save ref to original slice()

  var defaults = {
      topSpacing: 0,
      bottomSpacing: 0,
      className: 'is-sticky',
      wrapperClassName: 'sticky-wrapper',
      center: false,
      getWidthFrom: '',
      widthFromWrapper: true, // works only when .getWidthFrom is empty
      responsiveWidth: false,
      zIndex: 'auto'
    },
    $window = $(window),
    $document = $(document),
    sticked = [],
    windowHeight = $window.height(),
    scroller = function() {
      var scrollTop = $window.scrollTop(),
        documentHeight = $document.height(),
        dwh = documentHeight - windowHeight,
        extra = (scrollTop > dwh) ? dwh - scrollTop : 0;

      for (var i = 0, l = sticked.length; i < l; i++) {
        var s = sticked[i],
          elementTop = s.stickyWrapper.offset().top,
          etse = elementTop - s.topSpacing - extra;

        //update height in case of dynamic content
        s.stickyWrapper.css('height', s.stickyElement.outerHeight());

        if (scrollTop <= etse) {
          if (s.currentTop !== null) {
            s.stickyElement
              .css({
                'width': '',
                'position': '',
                'top': '',
                'z-index': ''
              });
            s.stickyElement.parent().removeClass(s.className);
            s.stickyElement.trigger('sticky-end', [s]);
            s.currentTop = null;
          }
        }
        else {
          var newTop = documentHeight - s.stickyElement.outerHeight()
            - s.topSpacing - s.bottomSpacing - scrollTop - extra;
          if (newTop < 0) {
            newTop = newTop + s.topSpacing;
          } else {
            newTop = s.topSpacing;
          }
          if (s.currentTop !== newTop) {
            var newWidth;
            if (s.getWidthFrom) {
                newWidth = $(s.getWidthFrom).width() || null;
            } else if (s.widthFromWrapper) {
                newWidth = s.stickyWrapper.width();
            }
            if (newWidth == null) {
                newWidth = s.stickyElement.width();
            }
            s.stickyElement
              .css('width', newWidth)
              .css('position', 'fixed')
              .css('top', newTop)
              .css('z-index', s.zIndex);

            s.stickyElement.parent().addClass(s.className);

            if (s.currentTop === null) {
              s.stickyElement.trigger('sticky-start', [s]);
            } else {
              // sticky is started but it have to be repositioned
              s.stickyElement.trigger('sticky-update', [s]);
            }

            if (s.currentTop === s.topSpacing && s.currentTop > newTop || s.currentTop === null && newTop < s.topSpacing) {
              // just reached bottom || just started to stick but bottom is already reached
              s.stickyElement.trigger('sticky-bottom-reached', [s]);
            } else if(s.currentTop !== null && newTop === s.topSpacing && s.currentTop < newTop) {
              // sticky is started && sticked at topSpacing && overflowing from top just finished
              s.stickyElement.trigger('sticky-bottom-unreached', [s]);
            }

            s.currentTop = newTop;
          }

          // Check if sticky has reached end of container and stop sticking
          var stickyWrapperContainer = s.stickyWrapper.parent();
          var unstick = (s.stickyElement.offset().top + s.stickyElement.outerHeight() >= stickyWrapperContainer.offset().top + stickyWrapperContainer.outerHeight()) && (s.stickyElement.offset().top <= s.topSpacing);

          if( unstick ) {
            s.stickyElement
              .css('position', 'absolute')
              .css('top', '')
              .css('bottom', 0)
              .css('z-index', '');
          } else {
            s.stickyElement
              .css('position', 'fixed')
              .css('top', newTop)
              .css('bottom', '')
              .css('z-index', s.zIndex);
          }
        }
      }
    },
    resizer = function() {
      windowHeight = $window.height();

      for (var i = 0, l = sticked.length; i < l; i++) {
        var s = sticked[i];
        var newWidth = null;
        if (s.getWidthFrom) {
            if (s.responsiveWidth) {
                newWidth = $(s.getWidthFrom).width();
            }
        } else if(s.widthFromWrapper) {
            newWidth = s.stickyWrapper.width();
        }
        if (newWidth != null) {
            s.stickyElement.css('width', newWidth);
        }
      }
    },
    methods = {
      init: function(options) {
        var o = $.extend({}, defaults, options);
        return this.each(function() {
          var stickyElement = $(this);

          var stickyId = stickyElement.attr('id');
          var wrapperId = stickyId ? stickyId + '-' + defaults.wrapperClassName : defaults.wrapperClassName;
          var wrapper = $('<div></div>')
            .attr('id', wrapperId)
            .addClass(o.wrapperClassName);

          stickyElement.wrapAll(function() {
            if ($(this).parent("#" + wrapperId).length == 0) {
                    return wrapper;
            }
});

          var stickyWrapper = stickyElement.parent();

          if (o.center) {
            stickyWrapper.css({width:stickyElement.outerWidth(),marginLeft:"auto",marginRight:"auto"});
          }

          if (stickyElement.css("float") === "right") {
            stickyElement.css({"float":"none"}).parent().css({"float":"right"});
          }

          o.stickyElement = stickyElement;
          o.stickyWrapper = stickyWrapper;
          o.currentTop    = null;

          sticked.push(o);

          methods.setWrapperHeight(this);
          methods.setupChangeListeners(this);
        });
      },

      setWrapperHeight: function(stickyElement) {
        var element = $(stickyElement);
        var stickyWrapper = element.parent();
        if (stickyWrapper) {
          stickyWrapper.css('height', element.outerHeight());
        }
      },

      setupChangeListeners: function(stickyElement) {
        if (window.MutationObserver) {
          var mutationObserver = new window.MutationObserver(function(mutations) {
            if (mutations[0].addedNodes.length || mutations[0].removedNodes.length) {
              methods.setWrapperHeight(stickyElement);
            }
          });
          mutationObserver.observe(stickyElement, {subtree: true, childList: true});
        } else {
          if (window.addEventListener) {
            stickyElement.addEventListener('DOMNodeInserted', function() {
              methods.setWrapperHeight(stickyElement);
            }, false);
            stickyElement.addEventListener('DOMNodeRemoved', function() {
              methods.setWrapperHeight(stickyElement);
            }, false);
          } else if (window.attachEvent) {
            stickyElement.attachEvent('onDOMNodeInserted', function() {
              methods.setWrapperHeight(stickyElement);
            });
            stickyElement.attachEvent('onDOMNodeRemoved', function() {
              methods.setWrapperHeight(stickyElement);
            });
          }
        }
      },
      update: scroller,
      unstick: function(options) {
        return this.each(function() {
          var that = this;
          var unstickyElement = $(that);

          var removeIdx = -1;
          var i = sticked.length;
          while (i-- > 0) {
            if (sticked[i].stickyElement.get(0) === that) {
                splice.call(sticked,i,1);
                removeIdx = i;
            }
          }
          if(removeIdx !== -1) {
            unstickyElement.unwrap();
            unstickyElement
              .css({
                'width': '',
                'position': '',
                'top': '',
                'float': '',
                'z-index': ''
              })
            ;
          }
        });
      }
    };

  // should be more efficient than using $window.scroll(scroller) and $window.resize(resizer):
  if (window.addEventListener) {
    window.addEventListener('scroll', scroller, false);
    window.addEventListener('resize', resizer, false);
  } else if (window.attachEvent) {
    window.attachEvent('onscroll', scroller);
    window.attachEvent('onresize', resizer);
  }

  $.fn.sticky = function(method) {
    if (methods[method]) {
      return methods[method].apply(this, slice.call(arguments, 1));
    } else if (typeof method === 'object' || !method ) {
      return methods.init.apply( this, arguments );
    } else {
      $.error('Method ' + method + ' does not exist on jQuery.sticky');
    }
  };

  $.fn.unstick = function(method) {
    if (methods[method]) {
      return methods[method].apply(this, slice.call(arguments, 1));
    } else if (typeof method === 'object' || !method ) {
      return methods.unstick.apply( this, arguments );
    } else {
      $.error('Method ' + method + ' does not exist on jQuery.sticky');
    }
  };
  $(function() {
    setTimeout(scroller, 0);
  });
}));








/*!
 * VERSION: 1.7.6
 * DATE: 2015-12-10
 * UPDATES AND DOCS AT: http://greensock.com
 *
 * @license Copyright (c) 2008-2016, GreenSock. All rights reserved.
 * This work is subject to the terms at http://greensock.com/standard-license or for
 * Club GreenSock members, the software agreement that was issued with your membership.
 * 
 * @author: Jack Doyle, jack@greensock.com
 **/
var _gsScope="undefined"!=typeof module&&module.exports&&"undefined"!=typeof global?global:this||window;(_gsScope._gsQueue||(_gsScope._gsQueue=[])).push(function(){"use strict";var a=document.documentElement,b=window,c=function(c,d){var e="x"===d?"Width":"Height",f="scroll"+e,g="client"+e,h=document.body;return c===b||c===a||c===h?Math.max(a[f],h[f])-(b["inner"+e]||a[g]||h[g]):c[f]-c["offset"+e]},d=_gsScope._gsDefine.plugin({propName:"scrollTo",API:2,version:"1.7.6",init:function(a,d,e){return this._wdw=a===b,this._target=a,this._tween=e,"object"!=typeof d&&(d={y:d}),this.vars=d,this._autoKill=d.autoKill!==!1,this.x=this.xPrev=this.getX(),this.y=this.yPrev=this.getY(),null!=d.x?(this._addTween(this,"x",this.x,"max"===d.x?c(a,"x"):d.x,"scrollTo_x",!0),this._overwriteProps.push("scrollTo_x")):this.skipX=!0,null!=d.y?(this._addTween(this,"y",this.y,"max"===d.y?c(a,"y"):d.y,"scrollTo_y",!0),this._overwriteProps.push("scrollTo_y")):this.skipY=!0,!0},set:function(a){this._super.setRatio.call(this,a);var d=this._wdw||!this.skipX?this.getX():this.xPrev,e=this._wdw||!this.skipY?this.getY():this.yPrev,f=e-this.yPrev,g=d-this.xPrev;this.x<0&&(this.x=0),this.y<0&&(this.y=0),this._autoKill&&(!this.skipX&&(g>7||-7>g)&&d<c(this._target,"x")&&(this.skipX=!0),!this.skipY&&(f>7||-7>f)&&e<c(this._target,"y")&&(this.skipY=!0),this.skipX&&this.skipY&&(this._tween.kill(),this.vars.onAutoKill&&this.vars.onAutoKill.apply(this.vars.onAutoKillScope||this._tween,this.vars.onAutoKillParams||[]))),this._wdw?b.scrollTo(this.skipX?d:this.x,this.skipY?e:this.y):(this.skipY||(this._target.scrollTop=this.y),this.skipX||(this._target.scrollLeft=this.x)),this.xPrev=this.x,this.yPrev=this.y}}),e=d.prototype;d.max=c,e.getX=function(){return this._wdw?null!=b.pageXOffset?b.pageXOffset:null!=a.scrollLeft?a.scrollLeft:document.body.scrollLeft:this._target.scrollLeft},e.getY=function(){return this._wdw?null!=b.pageYOffset?b.pageYOffset:null!=a.scrollTop?a.scrollTop:document.body.scrollTop:this._target.scrollTop},e._kill=function(a){return a.scrollTo_x&&(this.skipX=!0),a.scrollTo_y&&(this.skipY=!0),this._super._kill.call(this,a)}}),_gsScope._gsDefine&&_gsScope._gsQueue.pop()();



/*!
 * VERSION: 0.5.1
 * DATE: 2014-07-17
 * UPDATES AND DOCS AT: http://greensock.com
 *
 * @license Copyright (c) 2008-2016, GreenSock. All rights reserved.
 * This work is subject to the terms at http://greensock.com/standard-license or for
 * Club GreenSock members, the software agreement that was issued with your membership.
 * 
 * @author: Jack Doyle, jack@greensock.com
 */
var _gsScope="undefined"!=typeof module&&module.exports&&"undefined"!=typeof global?global:this||window;(_gsScope._gsQueue||(_gsScope._gsQueue=[])).push(function(){"use strict";var a=function(b){var c=b.nodeType,d="";if(1===c||9===c||11===c){if("string"==typeof b.textContent)return b.textContent;for(b=b.firstChild;b;b=b.nextSibling)d+=a(b)}else if(3===c||4===c)return b.nodeValue;return d},b=_gsScope._gsDefine.plugin({propName:"text",API:2,version:"0.5.1",init:function(b,c,d){var e,f;if(!("innerHTML"in b))return!1;if(this._target=b,"object"!=typeof c&&(c={value:c}),void 0===c.value)return this._text=this._original=[""],!0;for(this._delimiter=c.delimiter||"",this._original=a(b).replace(/\s+/g," ").split(this._delimiter),this._text=c.value.replace(/\s+/g," ").split(this._delimiter),this._runBackwards=d.vars.runBackwards===!0,this._runBackwards&&(e=this._original,this._original=this._text,this._text=e),"string"==typeof c.newClass&&(this._newClass=c.newClass,this._hasClass=!0),"string"==typeof c.oldClass&&(this._oldClass=c.oldClass,this._hasClass=!0),e=this._original.length-this._text.length,f=0>e?this._original:this._text,this._fillChar=c.fillChar||(c.padSpace?"&nbsp;":""),0>e&&(e=-e);--e>-1;)f.push(this._fillChar);return!0},set:function(a){a>1?a=1:0>a&&(a=0),this._runBackwards&&(a=1-a);var b,c,d,e=this._text.length,f=a*e+.5|0;this._hasClass?(b=this._newClass&&0!==f,c=this._oldClass&&f!==e,d=(b?"<span class='"+this._newClass+"'>":"")+this._text.slice(0,f).join(this._delimiter)+(b?"</span>":"")+(c?"<span class='"+this._oldClass+"'>":"")+this._delimiter+this._original.slice(f).join(this._delimiter)+(c?"</span>":"")):d=this._text.slice(0,f).join(this._delimiter)+this._delimiter+this._original.slice(f).join(this._delimiter),this._target.innerHTML="&nbsp;"===this._fillChar&&-1!==d.indexOf("  ")?d.split("  ").join("&nbsp;&nbsp;"):d}}),c=b.prototype;c._newClass=c._oldClass=c._delimiter=""}),_gsScope._gsDefine&&_gsScope._gsQueue.pop()();


/*global jQuery */
/*!
* FitText.js 1.2
*
* Copyright 2011, Dave Rupert http://daverupert.com
* Released under the WTFPL license
* http://sam.zoy.org/wtfpl/
*
* Date: Thu May 05 14:23:00 2011 -0600
*/

(function( $ ){

  $.fn.fitText = function( kompressor, options ) {

    // Setup options
    var compressor = kompressor || 1,
        settings = $.extend({
          'minFontSize' : Number.NEGATIVE_INFINITY,
          'maxFontSize' : Number.POSITIVE_INFINITY
        }, options);

    return this.each(function(){

      // Store the object
      var $this = $(this);

      // Resizer() resizes items based on the object width divided by the compressor * 10
      var resizer = function () {
        $this.css('font-size', Math.max(Math.min($this.width() / (compressor*10), parseFloat(settings.maxFontSize)), parseFloat(settings.minFontSize)));
      };

      // Call once to set.
      resizer();

      // Call on resize. Opera debounces their resize by default.
      $(window).on('resize.fittext orientationchange.fittext', resizer);

    });

  };

})( jQuery );


jQuery(function(){
    jQuery(".element2").typed({
        strings: ["Innovators", "Distruptors", "Accession"],
        stringsElement: null,
            // typing speed
            typeSpeed: 100,
            // time before typing starts
            startDelay: 200,
            // backspacing speed
            backSpeed: 0,
            // time before backspacing
            backDelay: 1500,
            // loop
            loop: true,
            // false = infinite
            loopCount: false,
            // show cursor
            showCursor: true,
            // character for cursor
            cursorChar: "|",
            // attribute to type (null == text)
            attr: null,
            // either html or text
            contentType: 'html',
            // call when done callback function
            callback: function() {},
            // starting callback function before each string
            preStringTyped: function() {},
            //callback for every typed string
            onStringTyped: function() {},
            // callback for reset
            resetCallback: function() {}
    });
});




// window.sr = ScrollReveal();
// sr.reveal('.section-header h2');
// sr.reveal('.section-header span');
// sr.reveal('.section-header p');
// // sr.reveal('.section-header h2, .section-header span, .section-header p', { duration: 1000, delay: 1500, opacity, 0.2,  });


 homeBanner();

  // Home Banner
  function homeBanner(){
    var wh = jQuery(window).height();
    var ww = jQuery(window).width();
    jQuery('.home-banner').css({'height': wh + 'px'});

    if(ww > 768){

    jQuery('#home-expertise .overlay.shift-on').css({'min-height': wh + 'px'});

  } else{
    jQuery('#home-expertise .overlay.shift-on').css({'min-height': 'auto'});
  }

  }

  jQuery(document).ready(function(){
    homeBanner();
  });

  jQuery(window).load(function(){
    homeBanner();
  });

  window.onresize = function(event) {
    homeBanner();
  };



/* ========================================================================
 * DOM-based Routing
 * Based on http://goo.gl/EUTi53 by Paul Irish
 *
 * Only fires on body classes that match. If a body class contains a dash,
 * replace the dash with an underscore when adding it to the object below.
 *
 * .noConflict()
 * The routing is enclosed within an anonymous function so that you can
 * always reference jQuery with $, even when in .noConflict() mode.
 * ======================================================================== */

(function($) {

  // Use this variable to set up the common and page specific functions. If you
  // rename this variable, you will also need to rename the namespace below.
  var Sage = {
    // All pages
    'common': {
      init: function() {
        // JavaScript to be fired on all pages
      },
      finalize: function() {
        // JavaScript to be fired on all pages, after page specific JS is fired
      }
    },
    // Home page
    'home': {
      init: function() {
        // JavaScript to be fired on the home page
      },
      finalize: function() {
        // JavaScript to be fired on the home page, after the init JS
      }
    },
    // About us page, note the change from about-us to about_us.
    'about_us': {
      init: function() {
        // JavaScript to be fired on the about us page
      }
    }
  };

  // The routing fires all common scripts, followed by the page specific scripts.
  // Add additional events for more control over timing e.g. a finalize event
  var UTIL = {
    fire: function(func, funcname, args) {
      var fire;
      var namespace = Sage;
      funcname = (funcname === undefined) ? 'init' : funcname;
      fire = func !== '';
      fire = fire && namespace[func];
      fire = fire && typeof namespace[func][funcname] === 'function';

      if (fire) {
        namespace[func][funcname](args);
      }
    },
    loadEvents: function() {
      // Fire common init JS
      UTIL.fire('common');

      // Fire page-specific init JS, and then finalize JS
      $.each(document.body.className.replace(/-/g, '_').split(/\s+/), function(i, classnm) {
        UTIL.fire(classnm);
        UTIL.fire(classnm, 'finalize');
      });

      // Fire common finalize JS
      UTIL.fire('common', 'finalize');
    }
  };

  // Load Events
  $(document).ready(UTIL.loadEvents);





  // Menu INIT
  $(function() {
    $('#menu-main-nav').smartmenus({
    isPopup:    false,    // is this a popup menu (can be shown via the popupShow/popupHide methods) or a permanent menu bar
    mainMenuSubOffsetX: 0,    // pixels offset from default position
    mainMenuSubOffsetY: 0,    // pixels offset from default position
    subMenusSubOffsetX: 0,    // pixels offset from default position
    subMenusSubOffsetY: 0,    // pixels offset from default position
    subMenusMinWidth: '10em',   // min-width for the sub menus (any CSS unit) - if set, the fixed width set in CSS will be ignored
    subMenusMaxWidth: '20em',   // max-width for the sub menus (any CSS unit) - if set, the fixed width set in CSS will be ignored
    subIndicators:    false,   // create sub menu indicators - creates a SPAN and inserts it in the A
    subIndicatorsPos:   'prepend',  // position of the SPAN relative to the menu item content ('prepend', 'append')
    subIndicatorsText:  '+',    // [optionally] add text in the SPAN (e.g. '+') (you may want to check the CSS for the sub indicators too)
    scrollStep:     30,   // pixels step when scrolling long sub menus that do not fit in the viewport height
    scrollAccelerate: true,   // accelerate scrolling or use a fixed step
    showTimeout:    0,    // timeout before showing the sub menus
    hideTimeout:    0,    // timeout before hiding the sub menus
    showDuration:   0,    // duration for show animation - set to 0 for no animation - matters only if showFunction:null
    showFunction:   null,   // custom function to use when showing a sub menu (the default is the jQuery 'show')
              // don't forget to call complete() at the end of whatever you do
              // e.g.: function($ul, complete) { $ul.fadeIn(250, complete); }
    hideDuration:   0,    // duration for hide animation - set to 0 for no animation - matters only if hideFunction:null
    hideFunction:   function($ul, complete) { $ul.fadeOut(200, complete); },  // custom function to use when hiding a sub menu (the default is the jQuery 'hide')
              // don't forget to call complete() at the end of whatever you do
              // e.g.: function($ul, complete) { $ul.fadeOut(250, complete); }
    collapsibleShowDuration:0,    // duration for show animation for collapsible sub menus - matters only if collapsibleShowFunction:null
    collapsibleShowFunction:function($ul, complete) { $ul.slideDown(200, complete); },  // custom function to use when showing a collapsible sub menu
              // (i.e. when mobile styles are used to make the sub menus collapsible)
    collapsibleHideDuration:0,    // duration for hide animation for collapsible sub menus - matters only if collapsibleHideFunction:null
    collapsibleHideFunction:function($ul, complete) { $ul.slideUp(200, complete); },  // custom function to use when hiding a collapsible sub menu
              // (i.e. when mobile styles are used to make the sub menus collapsible)
    showOnClick:    false,    // show the first-level sub menus onclick instead of onmouseover (i.e. mimic desktop app menus) (matters only for mouse input)
    hideOnClick:    true,   // hide the sub menus on click/tap anywhere on the page
    noMouseOver:    false,    // disable sub menus activation onmouseover (i.e. behave like in touch mode - use just mouse clicks) (matters only for mouse input)
    keepInViewport:   true,   // reposition the sub menus if needed to make sure they always appear inside the viewport
    keepHighlighted:  true,   // keep all ancestor items of the current sub menu highlighted (adds the 'highlighted' class to the A's)
    markCurrentItem:  true,    // automatically add the 'current' class to the A element of the item linking to the current URL
    markCurrentTree:  true,   // add the 'current' class also to the A elements of all ancestor items of the current item
    rightToLeftSubMenus:  false,    // right to left display of the sub menus (check the CSS for the sub indicators' position)
    bottomToTopSubMenus:  false,    // bottom to top display of the sub menus
    overlapControlsInIE:  true    // make sure sub menus appear on top of special OS controls in IE (i.e. SELECT, OBJECT, EMBED, etc.)
  });
  });



  // Menu Hamburger Animate
  $('#main-nav').on('hide.bs.collapse', function () {
    $('.main-nav-toggle').removeClass('is-active');
  });

  $('#main-nav').on('show.bs.collapse', function () {
     $('.main-nav-toggle').addClass('is-active');
  });



  $( ".definition-text" ).mouseover(function() {
    $( ".definition-text" ).removeClass('active');
    $( this ).addClass('active');
  });


var isiPad = navigator.userAgent.match(/iPad/i) != null;

if(isiPad){
  // $('.banner-arrow').hide();
  // $('.service-links').hide();
}


  //Scroll Menu

  function menuToggle()
  {
    var windowWidth = $(window).width();

    if(windowWidth > 767 ){
      $(window).on('scroll', function(){
        if( $(window).scrollTop()>405 ){
          $('.main-header').addClass('fixed-menu animated slideInDown');
        } else {
          $('.main-header').removeClass('fixed-menu animated slideInDown');
        }
      });
    }else{
      
      $('.main-header').addClass('fixed-menu animated slideInDown');
        
    }
  }

  menuToggle();
  

  $( window ).resize(function() {
    menuToggle();
  });



jQuery(".banner-text h1").fitText();
jQuery(".banner-text h1 span").fitText(1.2, { minFontSize: '30px', maxFontSize: '50px' });




// Get the height of the header
var headerHeight = $(".main-header").height();
var navHeight = $(".service-links").height();

var totHeight = headerHeight + navHeight -2;

console.log(totHeight);

$('a[href^="#"]').on('click',function (e) {
        e.preventDefault();

        var target = this.hash,
        $target = $(target);

        $('html, body').stop().animate({
            'scrollTop': $target.offset().top - totHeight
        }, 1200, 'swing');
    });




$(".service-links").sticky({topSpacing:80});
$('.service-links').on('sticky-start', function() { $(".banner-arrow").fadeOut();});
$('.service-links').on('sticky-end', function() { $(".banner-arrow").fadeIn();  });
$('body').scrollspy({ target: '.service-links',  offset: totHeight })


$(window).on('load', function() {

 $(".slider").owlCarousel({
      navigation : false, // Show next and prev buttons
      slideSpeed : 300,
      paginationSpeed : 400,
      items:1, 
      loop: true,
      autoplay:true,
      autoplayTimeout:3500,
      // autoplayHoverPause:true,
  });

  });


//  ;(function() {
  
//   'use strict';
  
//   var btn = document.querySelector('.button'), 
//       heading = document.querySelector('h1, h2'),

//       subheading = document.querySelector('.section-header>p'),
//       sepline = document.querySelector('.sep-line'),
//       brand = document.querySelector('.brand'),
//       headingTL = new TimelineMax(),

//       subheadingTL = new TimelineMax(),
//       seplineTL = new TimelineMax();

  
//   var animateIn = function() {
//     headingTL.fromTo( heading, 2, { y: '40', opacity: 0, delay: .30 }, { y: 0, opacity: 1, delay: 0, ease: Power1.easeOut } );

//     subheadingTL.fromTo( subheading, 1.5, { y: '40', opacity: 0, delay: .30 }, { y: 0, opacity: 1, delay: 0.5, ease: Power1.easeOut } );
//     seplineTL.fromTo( sepline, 1, { y: '40', opacity: 0, css:{width: '0px', opacity: '0', top: '40px'} }, { y: 0, opacity: 1, css:{width: '200px', opacity: '1', top: '0px'}, opacity: 1, delay: 1, ease: Power1.easeOut } );
//   };
  
//   animateIn();


// })();


})(jQuery); // Fully reference jQuery after this point.
